import { List, ListItemButton, ListItem, styled } from "@mui/material";

import colors from "../../theme/themeConstants";

interface ITopics {
  [code: string]: string;
}

interface IProps {
  topics: ITopics;
  active: string;
  changeTopic: (topic: string) => void;
}

export const TopicSelector = (props: IProps) => {
  const { topics, active, changeTopic } = props;

  const onClick = (code: string) => () => {
    changeTopic(code);
  };

  return (
    <List
      className="topicSelector"
      component="nav"
      sx={{
        position: "relative",
        display: "flex",
        height: "60px",
        alignItems: "center",
        padding: 0,
        width: "100%",
        overscrollBehavior: "contain",
        msOverflowStyle: "none",
        scrollbarWidth: "0 !important",
        overflowX: "hidden",
        "& *": {
          fontFamily: "'Poppins', sans-serif",
        },
        "::-webkit-scrollbar": {
          display: "none",
        }
      }}

    >
      {Object.keys(topics).map((topic, index) => {
        return (
          <StyledListItem onClick={onClick(topic)} key={topic} sx={{
            div: { width: "max-content" },
          }} isCurrentTopic={topic === active} >
            <ListItemButton sx={{ padding: 0 }}>{topics[topic]}</ListItemButton>
          </StyledListItem>
        );
      })}
    </List>
  );
};

const StyledListItem = styled(ListItem,
  { shouldForwardProp: (prop) => prop !== "isCurrentTopic" }
)<{ isCurrentTopic: boolean }>(({ isCurrentTopic }) => {
  return {
    flexDirection: "column",
    display: "relative",
    color: isCurrentTopic ? colors.white : colors.lightGrayText,

    "&::after": isCurrentTopic ? {
      // eslint-disable-next-line
      content: '""',
      width: "18px",
      borderRadius: "25px",
      height: "2px",
      top: "8px",
      background: "linear-gradient(180deg, #8F2CF2 0%, #CD4CFF 100%);",
    } : {}
  };
});
